import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';

export abstract class BaseBrandComponent {
  protected _destroyRef = inject(DestroyRef);
  protected _cdRef = inject(ChangeDetectorRef);
}
